//Please add the language resource
const blackList = {
  vehicleNo:'车牌号',
  supplierName:'货主',
  blacklistTypeName:'黑名单类型',
  blacklistReason:'禁入原因',
  expirationDateBeign: '有效期开始时间',
  expirationDateEnd:'有效期结束时间',
  validOrNot: '状态',
  expirationDate: '有效日期',
  msg:{
  }
};
export default blackList



// WEBPACK FOOTER //
// ./src/page/md/blackList/lang/blackList.en.js